// Invitation Constants
export const INVITE_URL = `/api/invitation`
export const SEND_INVITE = `${INVITE_URL}/send_invite`
export const CREATE_INVITE_LINK = `${INVITE_URL}/create_invite_link`
export const RESEND_INVITE = `${INVITE_URL}/resend_invite`
export const DELETE_INVITE = `${INVITE_URL}/delete_invite`
export const ALL_INVITES = `${INVITE_URL}/all_invites`
export const INVITE_BREAK_DOWN = `${INVITE_URL}/breakdown`
export const PROCESS_INVITE = `${INVITE_URL}/process_invite`
export const CHECK_INVITE = `${INVITE_URL}/check_invite`
export const LOAD_INVITE = `${INVITE_URL}/details`
export const EDIT_INVITE = (id) => `${INVITE_URL}/edit/${id}`